import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Home, Search, ShoppingCart, User } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useCart } from "@/context/CartContext";

const MobileNav = () => {
  const { count } = useCart();
  const items = [
    { to: "/", icon: Home, label: "Accueil", id: "home" },
    { to: "/recherche", icon: Search, label: "Recherche", id: "search" },
    { to: "/panier", icon: ShoppingCart, label: "Panier", id: "cart", badge: count },
    { to: "/compte", icon: User, label: "Compte", id: "account" },
  ];
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-4 border-t border-gray-200 bg-white/80 backdrop-blur-xl md:hidden">
      {items.map(({ to, icon: I, label, id, badge }) => (
        <NavLink key={id} to={to} end={to === "/"} data-testid={`mobile-nav-${id}`}
          className={({ isActive }) => `relative flex flex-col items-center gap-0.5 py-2 text-[11px] font-semibold ${isActive ? "text-orange-600" : "text-gray-500"}`}>
          <I className="h-5 w-5" /> {label}
          {badge > 0 && <span className="absolute right-[30%] top-1 rounded-full bg-orange-500 px-1.5 text-[10px] text-white">{badge}</span>}
        </NavLink>
      ))}
    </nav>
  );
};

export const Layout = () => {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen">
      <Header />
      <main key={pathname} className="page-enter">
        <Outlet />
      </main>
      <Footer />
      <MobileNav />
    </div>
  );
};
